import ConfirmOrderStepper from './ConfirmOrderStepper';
import PaymentNoteStep from './PaymentNoteStep';

export default {
  ConfirmOrderStepper,
  PaymentNoteStep,
}